<template>
	<div class="bill-conn">
		<router-link
			class="bill-conn__name"
			:to="{ query: { page: 'project', id: row.project?.Id } }"
		>
			{{ row.project?.Name || '[проект]' }}
		</router-link>
		<span class="bill-conn__field">
			<span class="bill-conn__cap">%:</span>
			<app-input
				class="bill-conn__inp"
				type="number"
				:model-value="row.AmountPercentText"
				:show-clear-button="false"
				:error="!row.AmountPercentValid || !!percentError"
				@update:model-value="(v) => emit('input', 0, v)"
				@blur="emit('blurField')"
			/>
		</span>

		<span class="bill-conn__field">
			<span class="bill-conn__cap">сумма:</span>
			<app-input
				class="bill-conn__inp"
				type="number"
				:model-value="row.AbsoluteAmountText"
				:show-clear-button="false"
				:error="!row.AbsoluteAmountValid || !!amountError"
				@update:model-value="(v) => emit('input', 1, v)"
				@blur="emit('blurField')"
			/>
		</span>

		<span class="bill-conn__field">
			<span class="bill-conn__cap">дебет:</span>
			<app-input
				class="bill-conn__inp"
				type="number"
				:model-value="row.PayedAmountText"
				:show-clear-button="false"
				:error="!row.PayedAmountValid || !!payedError"
				@update:model-value="(v) => emit('input', 2, v)"
				@blur="emit('blurField')"
			/>
		</span>

		<span class="bill-conn__bar">
			<span
				class="bill-conn__bar-fill"
				:style="{ width: barWidth(row.PayedPercent) }"
			/>
		</span>

		<app-icon
			class="bill-conn__detach"
			name="close"
			width="10px"
			color="#D2D2D2"
			hover-color="#499259"
			cursor="pointer"
			title="Отвязать"
			@click="emit('detach')"
		/>
	</div>
</template>

<script setup lang="ts">
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { EditableConnection } from "@/composables/useBillConnectionsEditor";
import { barWidth } from "../bill-format";

defineProps<{
	row: EditableConnection,
	percentError?: boolean,
	amountError?: boolean,
	payedError?: boolean,
}>()

const emit = defineEmits<{
	(e: 'input', type: number, value: string): void,
	(e: 'blurField'): void,
	(e: 'detach'): void,
}>()
</script>

<style scoped lang="scss">
.bill-conn {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
	font-size: 13px;
	line-height: 18px;
	color: #4D4D4D;

	&__name {
		font-weight: 500;
		color: #438451;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}

	&__field {
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	&__cap {
		color: #979797;
	}

	&__inp {
		width: 90px;
	}

	&__bar {
		display: inline-block;
		vertical-align: middle;
		width: 64px;
		height: 6px;
		border-radius: 3px;
		background: #EDEDED;
		overflow: hidden;

		&-fill {
			display: block;
			height: 100%;
			border-radius: 3px;
			background: #499259;
			transition: width 0.2s ease;
		}
	}

	&__detach {
		margin-left: 2px;
	}
}
</style>
